import { type ReactNode } from 'react';
import { AppLayout } from '../components/layout/app-layout';

/**
 * AppShell — chrome for every authenticated route.
 *
 * Thin adapter that delegates to the forked TailAdmin `AppLayout`
 * (`components/layout/app-layout.tsx`). The layout owns:
 *   - sidebar (collapsible + hover-expand + mobile drawer)
 *   - sticky header (search, theme toggle, user dropdown)
 *   - breadcrumbs slot above the main content
 *
 * Kept as a named export so `route-tree.tsx` does not have to change
 * shape — every protected route still wraps its page in `<AppShell>`.
 *
 * Anonymous / bootstrapping routes (login, password reset, accept-invite)
 * do not render the AppShell — they use the plain `RootLayout` chrome.
 */
export function AppShell({ children }: { children: ReactNode }) {
  return <AppLayout>{children}</AppLayout>;
}
